<template>
  <v-app>
    <!-- MENU LARETAL ESQUERDO -->
    <v-navigation-drawer
      v-if="(isLoggedIn && !$route.fullPath.includes('/laudo') && !isMobileApp)"
      v-model="drawer"
      app
      clipped
    >
      <v-list>
        <!-- MONTAGEM DOS ITENS DO MENU -->
        <v-list-item
          link
          v-for="item in itensMenu"
          :key="item.path"
          :to="{ name: item.path }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- MONTAGEM DOS ITENS DO MENU -->

        <!-- LOGOUT -->
        <v-list-item @click="sair()">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- CONTROLE DE TEMA -->
        <v-list-item>
          <v-switch
            v-model="dark"
            color="primary"
            label="Modo Noturno"
          ></v-switch>
        </v-list-item>

        <!-- LOGOUT -->
      </v-list>

      <!-- CONTROLE DE TEMA -->
      <span class="text-caption">
        <v-divider />
        <div>
          <center>
            Banco: {{ versao.banco }} Api: {{ versao.cgi }} Portal:
            {{ versao.vue }}
          </center>
        </div>
      </span>
    </v-navigation-drawer>
    <!-- MENU LARETAL ESQUERDO -->

    <!-- BARRA DE TÍTULOS -->
    <v-app-bar v-if="isLoggedIn && !isMobileApp" app clipped-left dense elevation="2">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        color="blue-grey darken-2"
      />
      <v-toolbar-title class="px-0">
        <v-img
          :src="logo"
          max-height="45"
          max-width="230"
          contain
          position="left"
          class="mr-2"
        />
      </v-toolbar-title>
      <v-toolbar-items>
        <img
          :src="require('@/assets/zoho-chat-online.png')"
          style="max-width: 138px; cursor: pointer"
          class="mr-2"
          @click="chatTele()"
          v-if="
            $route.fullPath.includes('telelaudo') &&
            !$route.fullPath.includes('portal')
          "
        />
      </v-toolbar-items>
      <v-row>
        <v-col cols="12" class="py-0 d-flex justify-end">
          <v-toolbar-title class="text-truncate d-none d-sm-flex">
            {{ usuario }}
          </v-toolbar-title>
          <v-toolbar-title class="text-truncate d-flex d-sm-none">
            {{ usuario | ajusteNome }}
          </v-toolbar-title>
        </v-col>
      </v-row>
    </v-app-bar>
    <!-- BARRA DE TÍTULOS -->
    <!-- CONTENT PRINCIPAL -->
    <v-main class="pb-0" v-if="logo">
      <v-row v-if="setup.ds_dicomvix_alert">
        <v-col class="py-0 mx-0">
          <v-card tile color="red lighten-1">
            <v-card-text
              class="white--text"
              :style="{ maxHeight: '100px', overflowY: 'auto' }"
              >{{ setup.ds_dicomvix_alert }}</v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
      <v-container :class="!isLoggedIn ? 'fill-height' : ''" fluid>
        <v-row :disabled="loading">
          <v-col class="py-0">
            <router-view />
          </v-col>
        </v-row>
      </v-container>

      <!-- INICIO DA TELA -->
      <v-scale-transition>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          :elevation="24"
          fab
          fixed
          bottom
          right
          color="primary"
          @click="toTop"
        >
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
      </v-scale-transition>
      <!-- INICIO DA TELA -->
    </v-main>
    <!-- CONTENT PRINCIPAL -->

    <!-- TERMO ACEITE COOKIES -->
    <termo-aceite-cookies
      v-if="$route.fullPath.includes('portal') && !isMobileApp"
    />

    <!-- FOOTER -->
    <v-footer color="primary" app v-if="false">
      <!-- <span class="white--text">&copy;{{ new Date().getFullYear() }} Genesis Tecnologia</span>-->
      <v-spacer />
      <span class="font-weight-light white--text text-caption">
        Banco: {{ versao.banco }} Api: {{ versao.cgi }} Portal:
        {{ versao.vue }}
      </span>
    </v-footer>
    <!-- FOOTER -->

    <!-- COMPONENTE ALERTA -->
    <v-snackbar
      v-model="alerta.ativo"
      top
      :color="alerta.tipo"
      :timeout="alerta.timeout"
    >
      {{ alerta.mensagem }}
      <v-btn dark text @click="alerta.ativo = false">Fechar</v-btn>
    </v-snackbar>
    <!-- COMPONENTE ALERTA -->

    <!-- MODAL PRELOADER REQUEST -->
    <modal-request />
    <!-- MODAL PRELOADER REQUEST -->

    <!-- CHAT OTRS -->
    <chat v-if="snOtrs" />
  </v-app>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import MixLayout from '@/mixins/layout'
import { favicon } from '@/mixins/utils'

export default {
  components: {
    ModalRequest: () => import('@/components/layout/ModalRequest'),
    Chat: () => import('@/pages/Otrs/Chat'),
    TermoAceiteCookies: () => import('@/components/TermoAceiteCookies')
  },
  mixins: [MixLayout],
  data: () => ({
    errors: [],
    fab: false
  }),
  filters: {
    ajusteNome (value) {
      if (value) {
        const nome = value?.split(' ')
        return value?.includes(' ') ? `${nome[0]} ${nome[1]}` : value
      } else {
        return ''
      }
    }
  },
  watch: {
    dark () {
      this.$vuetify.theme.dark = this.dark
      this.$store.commit('layout/definirModo', this.dark)
    },
    isLoggedIn () {
      this.atualizaChat()
      this.iniciaWidgetIndeCX()      
    }
  },
  created () {
    // Exibe chat Zoho apenas para Telelaudo
    this.snTelelaudo = (this.$route.fullPath.includes('telelaudo') || this.$route.fullPath.includes('local') || this.$route.fullPath.includes('sedi2')) && !this.$route.fullPath.includes('localhost')
    // this.snOtrs = this.$route.fullPath.includes('otrs')
    this.snHomologacao = window.location.host.includes('homologacao') || window.location.host.includes('localhost')
    this.SET_TOKEN(this.$route.fullPath.includes('telelaudo'))
    if (this.$route.fullPath.includes('telelaudo')) {
      this.$loadScript('https://js.huggy.chat/widget.min.js').then(() => {
        window.Huggy.init({
          defaultCountry: '+55',
          uuid: '742b6c16-0035-4a55-817b-817e010f60da',
          company: '327986',
          contextID: 'c1f1b0b26b2025654b5f4089bfd8b09b'
        })
      }).catch(() => {
        console.log('error loadScript')
      })
    }

    if (this.snTelelaudo) {
      this.$loadScript('https://indecx-widget.s3.amazonaws.com/widget.js').catch(err => {
        console.log('erro ao carregar script do IndeCX')
        console.error(err)
      })
    }
  },
  mounted () {
    this.abrirSetup(this.$route.params.empresa)
    this.exibeLogo()
    if (this.favicon) {
      favicon(this.favicon)
    }
  },
  computed: {
    ...mapGetters('login', ['currentUser', 'isLoggedIn']),
    ...mapState('layout', ['loading', 'isMobileApp']),
    ...mapFields('layout', ['dark', 'drawer', 'alerta', 'snTelelaudo', 'snOtrs', 'snHomologacao']),
    ...mapState('termoAceiteCookies', ['linkPolitica', 'snAceite']),
    ...mapState('login', ['logo', 'favicon', 'setup', 'versao', 'clinux', 'loginUrl', 'empresa']),
    usuario () {
      return this.isLoggedIn ? this.currentUser.ds_medico || this.currentUser.ds_paciente || this.currentUser.ds_cliente || this.currentUser.ds_funcionario : ''
    },
    itensMenu () {
      let lista = []
      switch (this.$route.fullPath.split('/')[1].toLowerCase()) {
        case 'clinux':
          lista = [
            { path: 'clinux', icon: 'mdi-home', text: 'Home' },
            { path: 'user', icon: 'mdi-clipboard-account', text: 'Usuário' }
          ]
          break
        case 'dicomvix':
          lista = [
            { path: 'dicomvix', icon: 'mdi-home', text: 'Home' },
            { path: 'userMedico', icon: 'mdi-clipboard-account', text: 'Usuário' },
            { path: 'agenda', icon: 'mdi-calendar', text: 'Agenda' }
            // { path: 'repasse', icon: 'mdi-file-replace', text: 'Repasse' }
          ]
          if (this.setup.sn_dicomvix_repasse) {
            lista.push({ path: 'repasse', icon: 'mdi-file-replace', text: 'Repasse' })
          }
          break
        case 'portal':
          lista = [
            { path: 'portal', icon: 'mdi-home', text: 'Home' },
            { path: 'editarPaciente', icon: 'mdi-clipboard-account', text: 'Cadastro' }
          ]
          if (this.setup.sn_agenda_agendamento || this.setup.sn_agenda_consultorio) {
            lista.push({ path: 'dependentes', icon: 'mdi-clipboard-account', text: 'Dependentes' })
          }
          if (this.setup.sn_agenda_agendamento) {
            lista.push({ path: 'agendamento', icon: 'mdi-calendar', text: 'Agendar Exame' })
          }
          if (this.setup.sn_agenda_consultorio) {
            lista.push({ path: 'consultorio', icon: 'mdi-calendar', text: 'Agendar Consulta' })
          }
          break
        case 'otrs':
          lista = [
            { path: 'otrs', icon: 'mdi-home', text: 'Home' },
            { path: 'chamados', icon: 'mdi-help-circle', text: 'Chamados' },
            { path: 'cliente', icon: 'mdi-clipboard-account', text: 'Usuário' },
            { path: 'atualizacoes', icon: 'mdi-history', text: 'Atualizações' }
          ]
          if (this.currentUser.sn_gestor) {
            lista.push(
              { path: 'empresas', icon: 'business', text: 'Empresas' },
              { path: 'funcionarios', icon: 'mdi-account-box', text: 'Funcionários' }
            )
          }
          break
        case 'solicitante':
          lista = [
            { path: 'sol-home', icon: 'mdi-home', text: 'Home' },
            { path: 'userSolicitante', icon: 'mdi-clipboard-account', text: 'Usuário' }
          ]
          break
        case 'painel':
          lista = [
            { path: 'mega01', icon: 'mdi-file-replace', text: 'Informativo' },
            { path: 'mega02', icon: 'mdi-file-replace', text: 'Tma' }
          ]
          break
        case 'anamnese':
          if (this.currentUser?.permissoes?.editar) {
            lista.push(
              // { path: 'anamnese', icon: 'mdi-home', text: 'Home' },
              { path: 'questionarios', icon: 'library_books', text: 'Questionários' },
              { path: 'grupos-opcoes', icon: 'list', text: 'Respostas' },
              // { path: 'avisos', icon: 'mdi-information', text: 'Avisos' },
              { path: 'perguntas', icon: 'live_help', text: 'Perguntas' }
              // { path: 'lixeira', icon: 'mdi-delete', text: 'Lixeira' }
            )
          }

          if (this.currentUser?.permissoes?.entrevista) {
            lista.push(
              { path: 'responder', icon: 'mdi-home', text: 'Entrevistas' }
            )
          }
          break
      }
      return lista
    }
  },

  methods: {
    ...mapActions('login', ['portalSetup', 'exibeLogo', 'logout']),
    ...mapActions('termoAceiteCookies', ['aceitar']),
    ...mapMutations('laudite', ['SET_TOKEN']),
    // ...mapMutations('dicomvix', ['SET_FILTRO_CONFIG']),
    onScroll (e) {
      if (window) {
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.fab = top > 100
      }
    },

    toTop () {
      this.$vuetify.goTo(0)
    },
    /*
        chatZoho () {
          document.querySelector('div#siqbtndiv').click()
        },
    */
    chatTele () {
      window.Huggy.openBox()
      // window.Huggy.closeBox(false)
    },

    abrirSetup (empresa) {
      this.portalSetup(empresa || this.empresa).then(response => {
        this.$vuetify.theme.themes.light.primary = this.setup.ds_dicomvix_tema || this.$vuetify.theme.themes.light.primary
        this.$vuetify.theme.themes.light.accent = this.setup.ds_dicomvix_tema || this.$vuetify.theme.themes.light.accent
        this.$vuetify.theme.themes.dark.primary = this.setup.ds_dicomvix_tema || this.$vuetify.theme.themes.dark.primary
        this.$vuetify.theme.themes.dark.accent = this.setup.ds_dicomvix_tema || this.$vuetify.theme.themes.dark.accent
        this.$vuetify.theme.dark = this.dark
      }).catch(e => {
        this.exibeAlerta(e)
      })
    },
    sair () {
      const user = this.currentUser
      const loginUrl = this.loginUrl
      const snAceite = this.snAceite
      this.logout().then(() => {
        if (snAceite) this.aceitar() // mantem o aceite em caso de logoff
        if (this.$route.fullPath.includes('otrs')) {
          document.querySelectorAll('#lhc_status_container, #lhc_container').forEach(elem => elem.remove())
        }
        this.$store.commit('clinux/RESET')
        this.$store.commit('laudo/RESET')
        this.$store.commit('dicomvix/RESET_FILTRO', !this.snTelelaudo)
        this.$store.commit('dicomvix/REMOVE_STORAGE')
        this.$store.commit('agendamento/RESET_FILTRO')
        this.$store.commit('agendamento/RESET_MODALIDADE')

        if (loginUrl.includes('/app')) {
          this.$router.push(loginUrl)
        } else if (user.sn_resultado) {
          this.$router.push({ name: 'resultados' })
        } else {
          this.$router.push({ path: 'login' })
        }
      })
    },
    atualizaChat () {
      if (document.getElementById('lhc_container_v2')) {
        if (this.isLoggedIn) {
          document.getElementById('lhc_container_v2').style.display = 'block'
        } else {
          document.getElementById('lhc_container_v2').style.display = 'none'
        }
      }
    },
    iniciaWidgetIndeCX () {
      if (this.$route.fullPath.includes('telelaudo') && this.currentUser?.ds_email && window.hasOwnProperty('IndeCX')) {
        const { IndeCX }  = require('@/env/telelaudo')
        if (IndeCX.key && IndeCX.action && IndeCX.indicators) {
          window.IndeCX({
            key: IndeCX.key,
            action: IndeCX.action,
            name: this.currentUser.ds_paciente,
            email: this.currentUser.ds_email,
            indicators: IndeCX.indicators
          })
        }
      }
    },
    /*
    atualizaChat () {
      if (this.isLoggedIn) {
        if (document.getElementsByTagName('jdiv')[0]) document.getElementsByTagName('jdiv')[0].style.display = ''
        this.$loadScript('https://code-sa1.jivosite.com/widget/rFvHZenCZ6').then(() => {
          window.jivo_onOpen = () => {
            window.jivo_api.setUserToken(this.currentUser.cd_cliente.toString())
            window.jivo_api.setContactInfo({
              name: this.currentUser.ds_cliente.toString(),
              email: this.currentUser.ds_email.toString(),
              phone: '',
              description: ''
            })
          }
          console.log('open chat', window.jivo_api)
        }).catch(() => {
          console.log('error loadScript')
        })
      } else {
        this.$unloadScript('https://code-sa1.jivosite.com/widget/rFvHZenCZ6').then(() => {
          if (document.getElementsByTagName('jdiv')[0]) document.getElementsByTagName('jdiv')[0].style.display = 'none'
          console.log('hide chat')
        }).catch(() => {
          console.log('error unloadScript')
        })
      }
    }
    */
  }

}
</script>

<style>
.moveable-control-box {
  display: none !important;
}
</style>
